export default __webpack_public_path__ + "static/media/51.fe25dbd2.png";